import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { NumberFormat } from 'components/Elements'

import { Table } from '../Table'

export const CandidatesBlock = ({ data = {} }) => {
  const { t } = useTranslation()

  const { period_logins, period, total } = data

  const items = [
    {
      label: t('logins_amount'),
      Cell: () => <NumberFormat value={period_logins} />,
    },
    {
      label: t('amount'),
      Cell: () => <NumberFormat value={period} />,
    },
    {
      label: t('total_amount'),
      Cell: () => <NumberFormat value={total} />,
    },
  ]

  return (
    <>
      <h4 className="font-size-18">{t('candidates')}</h4>

      <Table items={items} />
    </>
  )
}

CandidatesBlock.propTypes = {
  data: PropTypes.object,
}
